import React, { useState } from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import TranscriptText from './TranscriptText';

const TranscriptSection = ({ assessmentData, assessmentError }) => {
  const [showMore, setShowMore] = useState(false);

  const showButton =
    assessmentData?.formattedTranscription?.fullText?.length > 210;

  return (
    <div className="border-solid border border-gray-light bdrs-small mt-24 p-16 d-f fd-c">
      <div className="d-f jc-sb ai-b mb-16">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
          {t('automated_analysis.transcript.title')}
        </Text>
      </div>
      <>
        <TranscriptText
          assessmentData={assessmentData}
          assessmentError={assessmentError}
          fullText={showMore}
        />
        {showButton && (
          <button
            aria-label={showMore ? 'show-less-btn' : 'show-more-btn'}
            type="button"
            className="u-resetBtn c-link as-fe"
            onClick={() => setShowMore(prev => !prev)}
          >
            {showMore
              ? t('automated_analysis.transcript.button_less')
              : t('automated_analysis.transcript.button_more')}
          </button>
        )}
      </>
    </div>
  );
};

export default TranscriptSection;
